module.exports = __webpack_public_path__ + "static/media/lm2.41f03924.png";